<template>
    <template v-if="MIXIN_ACTIVITY_INFO.isEnd">
        <div class="end_text public_flex_center">
            <span>404</span>
        </div>
    </template>
    <template v-else>
        <div class="head_bg"></div>
        <div class="top_bar">
            <div class="top_btn" @click="handleClickTopBtn"></div>
        </div>
    </template>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import { RuleType } from './utils/type';
import { getQueryString } from '@activity-business/h5-package-frameworkTool';
import {fnGetInjectInfo} from '@components/developTool_Share';

const {
    TOOL_countryCode,
    TOOL_RULE,
    TOOL_TEXT,
    TOOL_DOMAIN,
    TOOL_activityId,
    TOOL_activityInfo
} = fnGetInjectInfo();

let refRuleType = ref<RuleType>(RuleType['规则1']);

const methodsClickActivityRuleType = (ruleType: RuleType) => refRuleType.value = ruleType;

const handleClickTopBtn = () => {
    let url = `https://mico.onelink.me/O5Dq/fcgadroe?entrance=11&business_type=1&func_type=1&encrypt=${getQueryString('encrypt')}&click_time=${Date.now()}`;
    console.log(url)
    window.location.href = url
}


</script>
<style lang="scss">
@use "./static/mixin.scss" as *;


#root,
body {
    width: 100%;
    min-height: 100vh;
    position: relative;
    height: max-content;
    background: #000;
    padding-top: 1.2rem;
    .end_text {
        position: fixed;
        width: 100%;
        height: 100%;
        padding-bottom: 1.2rem;
        left: 0;
        top: 0; 
        background: #FFF;

        span {
            font-size: 1.4rem;
            text-align: center;
            color: #666;
        }
    }
}

img {
    // IOS、android 全部禁止选中文本
    user-select: none;
    -webkit-user-select: none;
    // IOS 禁止长摁出现菜单
    -webkit-touch-callout: none;
    // IOS 禁止长摁后图片可拖动
    -webkit-user-drag: none;
}

div::-webkit-scrollbar {
    width: 0;
    height: 0;
}

.head_bg {
    width: 100%;
    height: 13.28rem;
    // margin-top: 1.2rem;
    @include bg('20250710-142555-1 (1)');
}

.top_bar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 1.2rem;
    @include bg('share_banner_open');

    .top_btn {
        scale: 1.1;
        position: absolute;
        top: 0.34rem;
        right: 0.32rem;
        width: 1.66rem;
        height: 0.52rem;
        background-color: transparent;
    }
}


.activite_ruleTyps {
    position: relative;
    width: 7.33rem;
    height: 1.92rem;
    @include bg('ds/Bottom-plate-1');
    margin: -0.53rem auto 0;
    padding: 0 0.16rem 0.05rem;
    z-index: 5;
    .item {
        width: 2.19rem;
        height: 1.56rem;
        padding: 0 0.3rem 0;
        z-index: 1;
        flex-shrink: 0;
        span {
                color: #7D7D7D;
                font-size: 0.28rem;
                font-weight: 700;
                line-height: 0.3rem;
                text-align: center;
            }
            &.active {
                span {
                    color: #A00003;
                }
            }
            &.btn1 {
                @include bg('ds/Layer-5');
                &.active {
                    @include bg('ds/Layer-2');
                }
            }
            &.btn2 {
                width: 2.64rem;
                height: 1.24rem;
                @include bg('ds/Layer-6');
                &.active {
                    @include bg('ds/Layer-6 (1)');
                }
            }
            &.btn3 {
                @include bg('ds/Dragon-Dance-Button-0001-Copy');
                &.active {
                    @include bg('ds/Dragon-Dance-Button-0001-Copy (1)');
                }
            }
    }
}

.rule_item {
    position: relative;
    width: 100%;
    margin: 0.2rem auto 0;
    z-index: 2;
}

#VN {
    .head_bg {
        @include bg('ds/Head-image-2');
    }
}
</style>
